import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('ispTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      selectedIspNames: '<',
      selectedLists: '<',
      ispNamesOptions: '<',
      allowList: "@",
      ispSource: "@",
      demandPartnerPermissionIds: "<",
      demandPartnerPermissionsInputId: "<"
    },
    template: require("../templates/ispTargeting.html"),
    controllerAs: '$ispTargetingCtrl',
    controller: function() {
      this.allowlistButtonOptions = componentHelper.allowlistOptions();
      this.targetingSourceOptions = componentHelper.targetingSourceOptions();
    }
});
